import { Navbar } from './components/Navbar'
import Footer from './components/Footer'
import Page from './Page'

// 레이아웃(Next app/layout.tsx)을 SPA로 옮긴 것. geist(next/font)와 Vercel
// Analytics/SpeedInsights는 Next 전용이라 제거 — 폰트는 styles.css의 system stack.
// 폭 제한은 섹션마다 두므로(max-w-5xl) 여기선 걸지 않는다 — 띠 배경이 화면 끝까지 가야 한다.
export default function App() {
  return (
    <div className="bg-page text-ink flex min-h-screen flex-col antialiased">
      <Navbar />
      <main className="flex-auto">
        <Page />
      </main>
      <Footer />
    </div>
  )
}
